(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__modern"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm100-hue-test"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ═══════════════════════════════════════════════════════
     FM 100-HUE SCORING ENGINE
  ═══════════════════════════════════════════════════════ */
  var TRAY_DEFS = [
    { id: 1, refStart: 85, refEnd: 22, caps: rng(1,  21) },
    { id: 2, refStart: 22, refEnd: 42, caps: rng(23, 41) },
    { id: 3, refStart: 42, refEnd: 63, caps: rng(43, 62) },
    { id: 4, refStart: 63, refEnd: 85, caps: rng(64, 84) }
  ];
  function rng(a, b) {
    var out = [];
    for (var i = a; i <= b; i++) out.push(i);
    return out;
  }
  function circDiff(a, b) {
    return Math.min(Math.abs(a - b), 85 - Math.abs(a - b));
  }
  function buildSeq(t1, t2, t3, t4) {
    return [85].concat(t1, [22], t2, [42], t3, [63], t4);
  }
  function score(t1, t2, t3, t4) {
    var seq = buildSeq(t1, t2, t3, t4);
    var n = 85;
    var cs = {};
    for (var p = 0; p < n; p++) {
      var prev = seq[(p - 1 + n) % n];
      var curr = seq[p];
      var next = seq[(p + 1) % n];
      cs[curr] = circDiff(prev, curr) + circDiff(curr, next);
    }
    var tes = 0;
    for (var c in cs) tes += cs[c] - 2;
    var cls, lbl;
    if (tes <= 16) { cls = 'Superior'; lbl = 'Superior / Advanced'; }
    else if (tes <= 40) { cls = 'Average';  lbl = 'Average / Standard'; }
    else                { cls = 'Low';      lbl = 'Low Discrimination'; }
    return { capScores: cs, tes: tes, cls: cls, lbl: lbl, knob: knoblauch(cs, n), seq: seq };
  }
  function knoblauch(cs, n) {
    var scores = [];
    for (var j = 0; j < n; j++) scores.push(cs[j+1] !== undefined ? cs[j+1] : 2);
    var M = 0;
    for (var i = 0; i < n; i++) M += scores[i];
    M /= n;
    var as = 0, ac = 0;
    for (var j2 = 0; j2 < n; j2++) {
      var ang = (4 * Math.PI * j2) / n;
      as += scores[j2] * Math.sin(ang);
      ac += scores[j2] * Math.cos(ang);
    }
    as /= 42.5; ac /= 42.5;
    var A = Math.sqrt(as*as + ac*ac);
    var phi = as >= 0 ? Math.atan2(ac, as) : Math.PI + Math.atan2(ac, as);
    var k = 85 / (4 * Math.PI);
    var a1 = ((k * (Math.PI/2 - phi) + 1 - 1 + 85*100) % 85) + 1;
    var a2 = ((k * (5*Math.PI/2 - phi) + 1 - 1 + 85*100) % 85) + 1;
    var beta = M > 0 ? A / M : 0;
    var fitted = [];
    for (var j3 = 0; j3 < n; j3++) fitted.push(M + A * Math.sin((4*Math.PI*j3)/n + phi));
    var MSE = 0;
    for (var j4 = 0; j4 < n; j4++) MSE += Math.pow(fitted[j4] - scores[j4], 2);
    MSE /= 82;
    var SE_A = Math.sqrt(MSE / 42.5);
    var SE_a = A > 0.001 ? (k * SE_A) / A : 999;
    return { M: M, A: A, a1: a1, a2: a2, beta: beta, SE_A: SE_A, SE_a: SE_a };
  }
  function capHue(cap) {
    return ((cap - 1) / 85) * 360;
  }
  function capColor(cap) {
    return 'hsl(' + capHue(cap).toFixed(1) + ',80%,58%)';
  }
  function capAngle(cap) {
    var deg = (((cap - 65 + 85) % 85) / 85) * 360;
    return deg * Math.PI / 180 - Math.PI / 2;
  }
  function axisLabel(a1) {
    var r = Math.round(a1);
    if ((r >= 14 && r <= 28) || (r >= 56 && r <= 70)) return 'Protan / Deutan (Red-Green)';
    if ((r >= 1  && r <= 10) || (r >= 43 && r <= 55)) return 'Tritan (Blue-Yellow)';
    return 'Non-specific';
  }
  function axisClass(a1) {
    var r = Math.round(a1);
    if ((r >= 14 && r <= 22) || (r >= 57 && r <= 65)) return 'protan';
    if ((r >= 22 && r <= 28) || (r >= 65 && r <= 70)) return 'deutan';
    if ((r >= 1  && r <= 10) || (r >= 43 && r <= 55)) return 'tritan';
    return 'none';
  }
  /*
     POLAR SCALE / X-RITE-STYLE REFERENCE
     ------------------------------------
     X-Rite-style interpretation used by this renderer:

     - The bold black circle is the ZERO-ERROR BASELINE. Its numeric scale
       value is 2 because a perfect cap has a raw score of 2.
     - Individual cap error is raw cap score - 2.
     - Therefore every perfect cap is plotted on value 2, and an error of n
       is plotted at value (2 + n).
     - TES is cumulative and NEVER controls radial scaling.
     - The maximum SINGLE-CAP ERROR controls whether the grid expands.

     Standard grid: 0, 2, 4, 8, 12
     Expanded grid: standard grid + 14, 16, 18, ... as required.
  */
  function polarGridValues(maxError) {
    var m = Math.max(0, Number(maxError) || 0);
    var values = [0,2,4,8,12];

    if (m > 12) {
      /* Add even-numbered scale values until the outer scale is at least
         two error points beyond the largest individual cap error. */
      var outer = Math.ceil((m + 2) / 2) * 2;
      for (var v = 14; v <= outer; v += 2) values.push(v);
    }
    return values;
  }

  /* ═══════════════════════════════════════════════════════
   POLAR SVG GENERATOR
═══════════════════════════════════════════════════════ */
function polarSVG(res, sz, light) {
  var cx = sz / 2, cy = sz / 2;

  /* Geometry anchors */
  var R_DOTS  = sz * 0.46;
  var R_LBL   = sz * 0.485;
  var R_INNER = R_DOTS * 0.22; // Innermost center ring radius

  var cs = res.capScores;

  /* -------------------------------------------------------
     FIND MAXIMUM INDIVIDUAL CAP ERROR

     Perfect cap:
       Raw cap score = 2
       Individual error = 0

     Therefore:
       Individual Error = Raw Cap Score - 2
  ------------------------------------------------------- */
  var maxIndivErr = 0;

  for (var c in cs) {
    var rawCapScore = Number(cs[c]);

    if (!isFinite(rawCapScore)) {
      rawCapScore = 2;
    }

    var indivErr = Math.max(0, rawCapScore - 2);

    if (indivErr > maxIndivErr) {
      maxIndivErr = indivErr;
    }
  }

  var TES = res.totalErrorScore || res.tes || 0;

  /* -------------------------------------------------------
     CURRENT RING COUNT LOGIC

     IMPORTANT:
     This section is intentionally unchanged.

     We are NOT changing your existing polar diagram
     scaling logic. The requested extra ring is added
     separately below.
  ------------------------------------------------------- */

    var totalRings = (TES <= 16) ? 6 : ((maxIndivErr >= 5) ? 9 : 8);
    if (maxIndivErr >= 2 && totalRings < 8) totalRings = 8;
    var slotSize = (R_DOTS - R_INNER) / (totalRings - 1);

    // If tallest spike would reach 90% of R_DOTS, add a ring
    if (R_INNER + (2 + maxIndivErr) * slotSize >= R_DOTS * 0.80) {
      totalRings += 1;
      slotSize = (R_DOTS - R_INNER) / (totalRings - 1);
    }

    var numErrorRings = totalRings - 3;
    function slotR(k) { return R_INNER + k * slotSize; }

  /*
   * Ring structure:
   *
   * Ring 0 = innermost circle
   * Ring 1 = spacer ring
   * Ring 2 = bold zero-error baseline
   */

  var R_BASE = slotR(2);

  /*
   * Existing score-to-radius mapping is intentionally
   * retained so the current diagram does not change.
   */
  function sToR(s) {
    return slotR(2 + Math.max(0, (s || 2) - 2));
  }

  /* -------------------------------------------------------
     NEW CONDITIONAL EXTRA RING

     Trigger condition:

       Individual Error > 10

     Equivalent to:

       Raw Cap Score > 12

     Example:

       Raw score 12 -> Error 10 -> NO extra ring
       Raw score 13 -> Error 11 -> EXTRA ring
       Raw score 14 -> Error 12 -> EXTRA ring
       Raw score 16 -> Error 14 -> EXTRA ring

     The existing diagram is NOT altered.

     The extra ring is inserted visually between:
       - the bold baseline ring
       - the first existing outer ring

     Therefore no existing ring moves.
  ------------------------------------------------------- */

  var needsExtraSpikeRing = maxIndivErr > 10;

  var R_EXTRA_SPIKE = null;

  if (needsExtraSpikeRing) {

    /*
     * Put the additional ring halfway between the
     * bold baseline and the first existing outer ring.
     *
     * Existing baseline:
     *     R_BASE = slotR(2)
     *
     * Existing first outer ring:
     *     slotR(3)
     *
     * New ring:
     *     halfway between them
     */
    R_EXTRA_SPIKE = R_BASE + ((slotR(3) - R_BASE) * 0.5);
  }

  /* -------------------------------------------------------
     COLORS
  ------------------------------------------------------- */

  var bg      = light ? 'white'    : '#0a1020';
  var thinC = light ? '#888888' : '#4a6080';
  var boldC   = light ? '#333333'  : '#3a5c80';
  var profC   = light ? '#1a1a1a'  : '#94a3b8';
  var lblC  = light ? '#555'    : '#94a3b8';
  var hlblC   = light ? '#111'     : '#f59e0b';
  var ctxtC   = light ? '#111'     : '#f8fafc';
  var csubC   = light ? '#888'     : '#64748b';
  var spokeC = light ? '#aaaaaa' : '#2a3a50';
  var dotBdr  = '#000000';

  var p = [];

  p.push(
    '<rect width="' + sz +
    '" height="' + sz +
    '" fill="' + bg +
    '" rx="' + (light ? 0 : 6) +
    '"/>'
  );

  /* -------------------------------------------------------
     RADIAL SPOKES

     Existing behavior retained:
     spokes start at the innermost circle and continue
     to the outer cap area.
  ------------------------------------------------------- */

  for (var si = 0; si < 85; si++) {

    var sa = capAngle(si + 1);

    p.push(
      '<line ' +
        'x1="' + f(cx + R_INNER * Math.cos(sa)) + '" ' +
        'y1="' + f(cy + R_INNER * Math.sin(sa)) + '" ' +
        'x2="' + f(cx + R_DOTS * 0.985 * Math.cos(sa)) + '" ' +
        'y2="' + f(cy + R_DOTS * 0.985 * Math.sin(sa)) + '" ' +
        'stroke="' + spokeC + '" ' +
        'stroke-width="0.5"/>'
    );
  }

  /* -------------------------------------------------------
     RING 0
     Innermost center circle
  ------------------------------------------------------- */

  p.push(
    '<circle ' +
      'cx="' + f(cx) + '" ' +
      'cy="' + f(cy) + '" ' +
      'r="' + f(R_INNER) + '" ' +
      'fill="none" ' +
      'stroke="' + thinC + '" ' +
      'stroke-width="0.4"/>'
  );

  /* -------------------------------------------------------
     RING 1
     Spacer ring
  ------------------------------------------------------- */

  p.push(
    '<circle ' +
      'cx="' + f(cx) + '" ' +
      'cy="' + f(cy) + '" ' +
      'r="' + f(slotR(1)) + '" ' +
      'fill="none" ' +
      'stroke="' + thinC + '" ' +
      'stroke-width="0.5"/>'
  );

  /* -------------------------------------------------------
     RING 2
     BOLD ZERO-ERROR BASELINE
  ------------------------------------------------------- */

  p.push(
    '<circle ' +
      'cx="' + f(cx) + '" ' +
      'cy="' + f(cy) + '" ' +
      'r="' + f(R_BASE) + '" ' +
      'fill="none" ' +
      'stroke="' + thinC + '" ' +
      'stroke-width="0.5"/>'
  );

  /* -------------------------------------------------------
     NEW CONDITIONAL RING

     Only appears when:
       max individual error > 10

     It is placed immediately outside the bold baseline,
     without changing any existing ring positions.
  ------------------------------------------------------- */

  if (needsExtraSpikeRing) {

    p.push(
      '<circle ' +
        'cx="' + f(cx) + '" ' +
        'cy="' + f(cy) + '" ' +
        'r="' + f(R_EXTRA_SPIKE) + '" ' +
        'fill="none" ' +
        'stroke="' + thinC + '" ' +
        'stroke-width="0.5"/>'
    );
  }

  /* -------------------------------------------------------
     EXISTING OUTER CONCENTRIC ERROR RINGS

     UNCHANGED
  ------------------------------------------------------- */

  for (var ri = 1; ri <= numErrorRings; ri++) {

    p.push(
      '<circle ' +
        'cx="' + f(cx) + '" ' +
        'cy="' + f(cy) + '" ' +
        'r="' + f(slotR(2 + ri)) + '" ' +
        'fill="none" ' +
        'stroke="' + thinC + '" ' +
        'stroke-width="0.5"/>'
    );
  }

  /* -------------------------------------------------------
     CONNECTED ERROR PROFILE PATH

     UNCHANGED
  ------------------------------------------------------- */

  var prof = '';

  for (var pi2 = 0; pi2 < 85; pi2++) {

    var cap = pi2 + 1;

    var sc = cs[cap] !== undefined
      ? cs[cap]
      : 2;

    var aa = capAngle(cap);

    var rE = sToR(sc);

    prof +=
      (pi2 === 0 ? 'M ' : 'L ') +
      f(cx + rE * Math.cos(aa)) +
      ' ' +
      f(cy + rE * Math.sin(aa)) +
      ' ';
  }

  prof += 'Z';

  p.push(
    '<path ' +
      'd="' + prof + '" ' +
      'fill="none" ' +
      'stroke="' + profC + '" ' +
      'stroke-width="' + (light ? 1.8 : 1.4) + '" ' +
      'stroke-linejoin="round" ' +
      'stroke-linecap="round"/>'
  );

  /* -------------------------------------------------------
     KNOBLAUCH AXIS LINES

     UNCHANGED
  ------------------------------------------------------- */

  var kn = res.knob;

  if (kn.A > 1.5) {

    var ac2 = axisClass(kn.a1);

    var acC =
      ac2 === 'protan' ? '#ef4444' :
      ac2 === 'deutan' ? '#22c55e' :
      ac2 === 'tritan' ? '#3b82f6' :
      '#6b7280';

    var axCaps = [
      Math.round(kn.a1),
      Math.round(kn.a2)
    ];

    for (var ai = 0; ai < 2; ai++) {

      var aang = capAngle(axCaps[ai]);

      p.push(
        '<line ' +
          'x1="' + f(cx + R_BASE * Math.cos(aang)) + '" ' +
          'y1="' + f(cy + R_BASE * Math.sin(aang)) + '" ' +
          'x2="' + f(cx + slotR(maxGV) * 0.97 * Math.cos(aang)) + '" ' +
          'y2="' + f(cy + slotR(maxGV) * 0.97 * Math.sin(aang)) + '" ' +
          'stroke="' + acC + '" ' +
          'stroke-width="1.4" ' +
          'stroke-dasharray="4,3" ' +
          'opacity="0.6"/>'
      );
    }
  }

  /* -------------------------------------------------------
     COLORED CAP DOTS
  ------------------------------------------------------- */

  for (var di = 0; di < 85; di++) {

    var dcap = di + 1;
    var da = capAngle(dcap);

    var dx =
      f(cx + R_DOTS * Math.cos(da));

    var dy2 =
      f(cy + R_DOTS * Math.sin(da));

    p.push(
      '<circle ' +
        'cx="' + dx + '" ' +
        'cy="' + dy2 + '" ' +
        'r="' + f(sz * 0.009) + '" ' +
        'fill="' + capColor(dcap) + '" ' +
        'stroke="' + dotBdr + '" ' +
        'stroke-width="0.7"/>'
    );
  }

  /* -------------------------------------------------------
     CAP LABELS
  ------------------------------------------------------- */

  for (var li = 0; li < 85; li++) {

    var lc = li + 1;
    var la = capAngle(lc);

    var lx =
      f(cx + R_LBL * Math.cos(la));

    var ly =
      f(cy + R_LBL * Math.sin(la));

    var lsc =
      cs[lc] !== undefined
        ? cs[lc]
        : 2;

    var isE = lsc > 2;

    p.push(
      '<text ' +
        'x="' + lx + '" ' +
        'y="' + ly + '" ' +
        'text-anchor="middle" ' +
        'dominant-baseline="middle" ' +
        'font-size="' + f(sz * 0.0145) + '" ' +
        'font-family="JetBrains Mono,monospace" ' +
        'fill="' + (isE ? hlblC : lblC) + '" ' +
        'font-weight="' + (isE ? 600 : 400) + '">' +
        lc +
      '</text>'
    );
  }

  /* -------------------------------------------------------
     CENTER TES DISPLAY
  ------------------------------------------------------- */

  p.push(
    '<text ' +
      'x="' + f(cx) + '" ' +
      'y="' + f(cy - sz * 0.005) + '" ' +
      'text-anchor="middle" ' +
      'dominant-baseline="central" ' +
      'font-size="' + f(sz * 0.055) + '" ' +
      'font-family="JetBrains Mono,monospace" ' +
      'fill="' + ctxtC + '" ' +
      'font-weight="700">' +
      res.tes +
    '</text>'
  );

  p.push(
    '<text ' +
      'x="' + f(cx) + '" ' +
      'y="' + f(cy + sz * 0.047) + '" ' +
      'text-anchor="middle" ' +
      'dominant-baseline="central" ' +
      'font-size="' + f(sz * 0.018) + '" ' +
      'font-family="Inter,sans-serif" ' +
      'fill="' + csubC + '" ' +
      'letter-spacing="0.1em">' +
      'TES' +
    '</text>'
  );

  return (
    '<svg width="' + sz +
    '" height="' + sz +
    '" viewBox="0 0 ' + sz + ' ' + sz +
    '" style="display:block;max-width:100%;height:auto">' +
    p.join('') +
    '</svg>'
  );
}
  function f(n) { return parseFloat(n.toFixed(2)); }
  /* ═══════════════════════════════════════════════════════
     UTILITIES
  ═══════════════════════════════════════════════════════ */
  var STEPS = ['Welcome','Subject Info','Cap Entry','Results','Report'];
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;');
  }
  function fmtDate(ds, long) {
    if (!ds) return '—';
    var d = new Date(ds + 'T12:00:00');
    if (long) return d.toLocaleDateString('en-US', {year:'numeric', month:'long', day:'numeric'});
    return d.toLocaleDateString('en-US', {year:'numeric', month:'2-digit', day:'2-digit'});
  }
  function today() { return new Date().toISOString().slice(0,10); }
  /* ═══════════════════════════════════════════════════════
     BLOCK FACTORY
  ═══════════════════════════════════════════════════════ */
  function initBlock(wrapper) {
    var state = {
      step: 0,
      sub: { name:'', reference:'', dob:'', testDate:today(), duration:'',
             gender:'', location:'', industry:'', jobFunction:'', experience:'',
             illumination:'D50', serialNumber:'', comments:'' },
      trays: [[],[],[],[]],
      results: null,
      pasteOpen: false,
      pasteText: '',
      pasteErr: ''
    };
    /* ── Persistent event delegation (added once) ── */
    wrapper.addEventListener('click', function(e) {
      var el = e.target.closest('[data-a]');
      if (el) dispatch(el.getAttribute('data-a'), el, e);
    });
    wrapper.addEventListener('input', function(e) {
      var t = e.target;
      var fld = t.getAttribute('data-f');
      if (fld) {
        state.sub[fld] = t.value;
        var btn = wrapper.querySelector('[data-a="step2"]');
        if (btn) btn.disabled = !state.sub.name;
      }
      if (t.id === 'paste-ta') state.pasteText = t.value;
    });
    wrapper.addEventListener('change', function(e) {
      var fld = e.target.getAttribute('data-f');
      if (fld) state.sub[fld] = e.target.value;
    });
    /* ── Dispatch ── */
    function dispatch(action, el) {
      if (action === 'start')      { goTo(1); }
      else if (action === 'back0') { goTo(0); }
      else if (action === 'step2') { if (state.sub.name) goTo(2); }
      else if (action === 'back1') { goTo(1); }
      else if (action === 'back2') { goTo(2); }
      else if (action === 'back3') { goTo(3); }
      else if (action === 'compute') { compute(); }
      else if (action === 'report')  { goTo(4); }
      else if (action === 'newtest') { reset(); }
      else if (action === 'print')   { window.print(); }
      else if (action === 'tpaste')  { state.pasteOpen = !state.pasteOpen; state.pasteErr = ''; renderMain(); }
      else if (action === 'cpaste')  { state.pasteOpen = false; state.pasteErr = ''; renderMain(); }
      else if (action === 'ipaste')  { importPaste(); }
      else if (action === 'undo') {
        var ti = parseInt(el.getAttribute('data-t'), 10);
        state.trays[ti] = state.trays[ti].slice(0,-1);
        renderMain();
      }
      else if (action === 'clear') {
        var ti2 = parseInt(el.getAttribute('data-t'), 10);
        state.trays[ti2] = [];
        renderMain();
      }
      else if (action === 'addcap') {
        var ti3 = parseInt(el.getAttribute('data-t'), 10);
        var cap = parseInt(el.getAttribute('data-c'), 10);
        var tdef = TRAY_DEFS[ti3];
        if (state.trays[ti3].length < tdef.caps.length && state.trays[ti3].indexOf(cap) === -1) {
          state.trays[ti3] = state.trays[ti3].concat([cap]);
          renderMain();
        }
      }
    }
    /* ── Navigation ── */
    function goTo(s) {
      state.step = s;
      render();
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function reset() {
      state.step = 0;
      state.sub = { name:'', reference:'', dob:'', testDate:today(), duration:'',
                    gender:'', location:'', industry:'', jobFunction:'', experience:'',
                    illumination:'D50', serialNumber:'', comments:'' };
      state.trays = [[],[],[],[]];
      state.results = null;
      state.pasteOpen = false;
      state.pasteText = '';
      state.pasteErr = '';
      render();
    }
    function compute() {
      var ok = TRAY_DEFS.every(function(t,i){ return state.trays[i].length === t.caps.length; });
      if (!ok) return;
      state.results = score(state.trays[0], state.trays[1], state.trays[2], state.trays[3]);
      goTo(3);
    }
    function importPaste() {
      var ta = wrapper.querySelector('#paste-ta');
      var txt = ta ? ta.value : state.pasteText;
      var nums = txt.split(/[\s,]+/).map(Number).filter(function(n){ return n>=1&&n<=85; });
      if (nums.length < 10) {
        state.pasteErr = 'Too few cap numbers found. Expected 81–85 values.';
        renderMain();
        return;
      }
      var full = nums.filter(function(n){ return n!==22&&n!==42&&n!==63&&n!==85; });
      var t1=full.filter(function(n){return n>=1&&n<=21;});
      var t2=full.filter(function(n){return n>=23&&n<=41;});
      var t3=full.filter(function(n){return n>=43&&n<=62;});
      var t4=full.filter(function(n){return n>=64&&n<=84;});
      state.trays = [
        nums.filter(function(n){return t1.indexOf(n)!==-1;}).slice(0,21),
        nums.filter(function(n){return t2.indexOf(n)!==-1;}).slice(0,19),
        nums.filter(function(n){return t3.indexOf(n)!==-1;}).slice(0,20),
        nums.filter(function(n){return t4.indexOf(n)!==-1;}).slice(0,21)
      ];
      state.pasteOpen = false;
      state.pasteText = '';
      state.pasteErr = '';
      renderMain();
    }
    /* ═══════════════════════════════════════════════════
       RENDER FUNCTIONS
    ═══════════════════════════════════════════════════ */
    function render() {
      renderHeader();
      renderMain();
    }
    function renderMain() {
      var m = wrapper.querySelector('.fm-main');
      if (!m) return;
      if (state.step === 0) m.innerHTML = htmlWelcome();
      else if (state.step === 1) m.innerHTML = htmlSubject();
      else if (state.step === 2) m.innerHTML = htmlCaps();
      else if (state.step === 3) m.innerHTML = htmlResults();
      else if (state.step === 4) m.innerHTML = htmlReport();
    }
    function renderHeader() {
      var h = wrapper.querySelector('.fm-header');
      if (!h) return;
      var dots = '';
      for (var i=0; i<5; i++) dots += '<span class="fm-logo-dot" style="background:hsl('+(i*72)+',65%,55%)"></span>';
      var nb = (state.step > 0 && state.step < 4) ? '<button class="fm-new-btn-header" data-a="newtest">↺ NEW TEST</button>' : '';
      var prog = '';
      if (state.step > 0) {
        prog = '<div class="fm-progress">';
        for (var s=0; s<STEPS.length; s++) {
          var cls2 = s===state.step ? 'active' : s<state.step ? 'done' : '';
          prog += '<div class="fm-prog-step '+cls2+'">';
          prog += '<div class="fm-prog-num">'+(s<state.step?'&#10003;':(s+1))+'</div>';
          prog += '<span class="fm-prog-label">'+STEPS[s]+'</span>';
          prog += '</div>';
        }
        prog += '</div>';
      }
      h.innerHTML = '<div class="fm-header-bar"><div class="fm-logo"><div class="fm-logo-dots">'+dots+'</div><span class="fm-logo-name">FM 100-HUE SCORING</span></div>'+nb+'</div>'+prog;
    }
    /* ── Welcome ── */
    function htmlWelcome() {
      var hues = '';
      for (var i=0;i<17;i++) hues += '<span class="hue-dot" style="background:hsl('+((i/17)*360).toFixed(0)+',70%,55%)"></span>';
      return '<div class="welcome">'+
        '<div class="welcome-hues">'+hues+'</div>'+
        '<p class="eyebrow">Munsell Color Vision Assessment</p>'+
        '<h1 class="welcome-h1">FM 100-Hue</h1>'+
        '<h2 class="welcome-h2">Scoring System</h2>'+
        '<p class="welcome-body">A modern web-based scoring tool for the Farnsworth-Munsell 100-Hue Test. Enter your subject&#39;s cap arrangement to compute error scores, generate polar diagrams, perform Knoblauch sine-wave analysis, and issue color vision qualification reports.</p>'+
        '<button class="btn-primary" data-a="start">Begin Scoring</button>'+
        '<div class="welcome-legend">'+
          '<div class="legend-card"><div class="legend-val" style="color:#22c55e;">&#8804; 16</div><div class="legend-desc">Superior / Advanced</div></div>'+
          '<div class="legend-card"><div class="legend-val">17 – 40</div><div class="legend-desc">Average / Standard</div></div>'+
          '<div class="legend-card"><div class="legend-val" style="color:#ef4444;">&gt; 40</div><div class="legend-desc">Low Discrimination</div></div>'+
        '</div>'+
        '<p class="welcome-foot" style="color:#94a3b8;">Based on Farnsworth (1957) &amp; Knoblauch (1987) methods · 85 caps · 4 trays</p>'+
        '</div>';
    }
    /* ── Subject form ── */
    function selOpts(arr, cur) {
      var h='<option value="">— Select —</option>';
      for (var i=0;i<arr.length;i++) h+='<option value="'+esc(arr[i])+'"'+(cur===arr[i]?' selected':'')+'>'+esc(arr[i])+'</option>';
      return h;
    }
    function inp(f2,type,val,ph) {
      return '<input type="'+(type||'text')+'" data-f="'+f2+'" value="'+esc(val||'')+'"'+(ph?' placeholder="'+esc(ph)+'"':'')+((type==='number')?' min="0" oninput="if(this.value<0)this.value=0"':'')+' autocomplete="off">';
    }
    function sel(f2,opts,cur) {
      return '<select data-f="'+f2+'">'+selOpts(opts,cur)+'</select>';
    }
    function htmlSubject() {
      var s=state.sub;
      return '<div class="form-wrap">'+
        '<p class="eyebrow">Step 1 of 3</p>'+
        '<h2 class="step-title">Subject Information</h2>'+
        '<div class="form-grid">'+
          '<div class="field col2"><label>Full Name <span style="color:#ef4444;">*</span></label>'+inp('name','text',s.name,'e.g. First and Last Name')+'</div>'+
          '<div class="field"><label>Reference / ID</label>'+inp('reference','text',s.reference,'Optional')+'</div>'+
          '<div class="field"><label>Years Old</label>'+inp('dob','number',s.dob,'e.g. 34')+'</div>'+
          '<div class="field"><label>Date of Test <span style="color:#ef4444;">*</span></label>'+inp('testDate','date',s.testDate)+'</div>'+
          '<div class="field"><label>Duration (minutes)</label>'+inp('duration','number',s.duration,'e.g. 12')+'</div>'+
          '<div class="field"><label>Gender</label>'+sel('gender',['Male','Female','Non-binary','Prefer not to say'],s.gender)+'</div>'+
          '<div class="field"><label>Geographic Location</label>'+inp('location','text',s.location,'e.g. North America')+'</div>'+
          '<div class="field"><label>Industry Type</label>'+sel('industry',['Printer','Textile','Paint / Coatings','Plastics','Photography','Graphic Design','Medical','Other'],s.industry)+'</div>'+
          '<div class="field"><label>Primary Job Function</label>'+sel('jobFunction',['Color Scientist','Color Manager','Colorist','QC Inspector','Designer','Buyer','Other'],s.jobFunction)+'</div>'+
          '<div class="field"><label>Years of Experience</label>'+sel('experience',['Less than 1 year','1 – 5 years','6 – 10 years','11 – 20 years','20 + years'],s.experience)+'</div>'+
          '<div class="field"><label>Illumination Type</label>'+sel('illumination',['D50','D65','C','A','F2','F11','Other'],s.illumination)+'</div>'+
          '<div class="field"><label>Test Serial Number</label>'+inp('serialNumber','text',s.serialNumber,'Found on certification label')+'</div>'+
          '<div class="field col2"><label>Comments</label><textarea data-f="comments" rows="2" placeholder="Optional notes">'+esc(s.comments)+'</textarea></div>'+
        '</div>'+
        '<div class="form-actions">'+
          '<button class="btn-secondary" data-a="back0">Back</button>'+
          '<button class="btn-primary" data-a="step2"'+(s.name?'':' disabled')+'>Continue to Cap Entry →</button>'+
        '</div>'+
        '</div>';
    }
    /* ── Cap entry ── */
    function chip(cap, fixed, clickable, ti) {
      var col = capColor(cap);
      var hueVal = capHue(cap);
      var bg2 = 'hsla('+hueVal.toFixed(1)+',80%,58%,0.13)';
      var bd  = 'hsla('+hueVal.toFixed(1)+',80%,58%,'+(fixed?'0.4':'0.8')+')';
      var tc  = fixed ? '#64748b' : col;
      var cls3 = 'cap-chip'+(clickable?' click':'');
      var da  = clickable ? ' data-a="addcap" data-t="'+ti+'" data-c="'+cap+'"' : '';
      return '<div class="'+cls3+'" style="background:'+bg2+';border-color:'+bd+';color:'+tc+'"'+da+'>'+cap+'</div>';
    }
    function htmlTray(ti) {
      var tdef = TRAY_DEFS[ti];
      var sel2 = state.trays[ti];
      var avail = tdef.caps.filter(function(c){ return sel2.indexOf(c)===-1; });
      var full = sel2.length === tdef.caps.length;
      var seq = chip(tdef.refStart,true,false,ti);
      for (var i=0;i<sel2.length;i++) seq += chip(sel2[i],false,false,ti);
      if (!full) seq += '<span class="tray-seq-hint">← click caps below in order</span>';
      else seq += chip(tdef.refEnd,true,false,ti);
      var pool = full ? '<span class="tray-done-msg">✓ Tray complete</span>' : '';
      if (!full) for (var j=0;j<avail.length;j++) pool += chip(avail[j],false,true,ti);
      var cntCls = full ? 'tray-count full' : 'tray-count';
      var undoB = sel2.length>0 ? '<button class="tray-act" data-a="undo" data-t="'+ti+'">undo</button>' : '';
      var clrB  = sel2.length>0 ? '<button class="tray-act dng" data-a="clear" data-t="'+ti+'">clear</button>' : '';
      return '<div class="tray-block">'+
        '<div class="tray-top">'+
          '<div>'+
            '<div class="tray-eyebrow">Tray '+tdef.id+'</div>'+
            '<div class="tray-meta">Ref <span style="color:'+capColor(tdef.refStart)+'">'+tdef.refStart+'</span> → '+tdef.caps.length+' movable caps → Ref <span style="color:'+capColor(tdef.refEnd)+'">'+tdef.refEnd+'</span></div>'+
          '</div>'+
          '<div class="tray-controls"><span class="'+cntCls+'">'+sel2.length+' / '+tdef.caps.length+'</span>'+undoB+clrB+'</div>'+
        '</div>'+
        '<div class="tray-seq">'+seq+'</div>'+
        '<div class="tray-pool">'+pool+'</div>'+
        '</div>';
    }
    function htmlCaps() {
      var allDone = TRAY_DEFS.every(function(t,i){ return state.trays[i].length===t.caps.length; });
      var traysH=''; for(var i=0;i<4;i++) traysH+=htmlTray(i);
      var remain = TRAY_DEFS.filter(function(t,i){ return state.trays[i].length<t.caps.length; })
        .map(function(t,i){
          var idx=TRAY_DEFS.indexOf(t);
          return 'Tray '+t.id+' ('+(t.caps.length-state.trays[idx].length)+' caps)';
        }).join(', ');
      var pasteH = '';
      if (state.pasteOpen) {
        pasteH='<div class="paste-box">'+
          '<p>Paste the full cap order sequence (comma or space separated):</p>'+
          '<textarea id="paste-ta" placeholder="85, 1, 2, 3, 4, &#133;">'+esc(state.pasteText)+'</textarea>'+
          (state.pasteErr?'<p class="paste-error">'+esc(state.pasteErr)+'</p>':'')+
          '<div class="paste-actions">'+
            '<button class="btn-primary" data-a="ipaste" style="padding:8px 18px;font-size:10px">Import</button>'+
            '<button class="btn-secondary" data-a="cpaste" style="padding:8px 14px;font-size:10px">Cancel</button>'+
          '</div>'+
          '</div>';
      }
      return '<div class="caps-wrap">'+
        '<p class="eyebrow">Step 2 of 3</p>'+
        '<div class="caps-top"><h2 class="step-title" style="margin-bottom:0">Cap Arrangement</h2><button class="import-btn" data-a="tpaste">Import Cap Order</button></div>'+
        '<p class="caps-hint">Click each cap in the order it appears on the physical tray, from the reference cap at the start to the reference cap at the end.</p>'+
        pasteH + traysH +
        '<div class="form-actions">'+
          '<button class="btn-secondary" data-a="back1">Back</button>'+
          '<button class="btn-primary" data-a="compute"'+(allDone?'':' disabled')+'>Calculate Results →</button>'+
        '</div>'+
        (!allDone?'<p class="caps-remain">Complete all 4 trays to continue. Remaining: '+esc(remain)+'</p>':'')+
        '</div>';
    }
    /* ── Results ── */
    function htmlResults() {
      var r=state.results, kn=r.knob;
      var cls=r.cls;
      var clsC  = cls==='Superior'?'#22c55e':cls==='Average'?'#f59e0b':'#ef4444';
      var ac2   = axisClass(kn.a1);
      var axC   = ac2==='protan'?'#f87171':ac2==='deutan'?'#4ade80':ac2==='tritan'?'#60a5fa':'#94a3b8';
      var axLbl = axisLabel(kn.a1);
      var clsDesc = cls==='Superior'
        ? 'Total Error Score ≤ 16. Superior color discrimination — qualified for color-critical and advanced color evaluation roles.'
        : cls==='Average'
          ? 'Total Error Score 17–40. Average color discrimination — suitable for standard quality control and general color tasks.'
          : 'Total Error Score > 40. Low color discrimination. Not recommended for critical color evaluation roles.';
      var kgrid='';
      var kg = [['Mean Error (M)',kn.M.toFixed(2)],['Amplitude (A)',kn.A.toFixed(2)+' ± '+(1.96*kn.SE_A).toFixed(2)],['Modulation (β)',kn.beta.toFixed(3)],['Axis α₁',kn.a1.toFixed(1)],['Axis α₂',kn.a2.toFixed(1)],['SE Axis','± '+(1.96*kn.SE_a).toFixed(1)+' caps']];
      for(var ki=0;ki<kg.length;ki++) kgrid+='<div class="knob-cell"><div class="knob-lbl">'+esc(kg[ki][0])+'</div><div class="knob-val">'+esc(kg[ki][1])+'</div></div>';
      var cs=r.capScores, perfect=0, errs=0, maxE=0;
      var chips='';
      for(var ci=1;ci<=85;ci++){
        var sc=cs[ci]!==undefined?cs[ci]:2, er=sc-2;
        if(er===0) perfect++; else errs++;
        if(er>maxE) maxE=er;
        var indS=er===0?'background:transparent;border:1px solid #1e2740':'background:rgba(245,158,11,'+Math.min(er/10,1).toFixed(2)+');border:1px solid rgba(245,158,11,0.4)';
        chips+='<div class="cs-chip"><div class="cs-ind" style="'+indS+'">'+(er>0?er:'')+'</div><div class="cs-num">'+ci+'</div></div>';
      }
      var teh=Math.sqrt(Math.max(0,85*(kn.M-2))).toFixed(1);
      return '<div class="results-wrap">'+
        '<p class="eyebrow">Results</p>'+
        '<div class="results-head">'+
          '<div><div class="results-name">'+esc(state.sub.name||'Subject')+'</div><div class="results-meta">'+esc(state.sub.testDate)+' · '+esc(state.sub.illumination)+'</div></div>'+
          '<div><div class="results-tes" style="color:'+clsC+'">'+r.tes+'</div><div class="results-cls">'+esc(r.lbl)+'</div></div>'+
        '</div>'+
        '<div class="results-grid">'+
        '<div class="plot-box"><div style="display:flex;flex-direction:column;align-items:center;">'+polarSVG(r,440,false)+'<p style="margin:30px 0 0;font-size:11px;color:#94a3b8;text-align:center;max-width:440px;"><span style="color:#f59e0b;font-weight:600;">&#9679; Orange numbers</span> indicate caps placed out of sequence — these are your error positions and highlight where your color discrimination weakened.</p></div></div>'+
          '<div class="side-panels">'+
            '<div class="panel">'+
              '<div class="panel-lbl">Classification</div>'+
              '<div class="cls-row"><div class="cls-dot" style="background:'+clsC+'"></div><div class="cls-name" style="color:'+clsC+'">'+esc(r.lbl)+'</div></div>'+
              '<p class="cls-desc">'+esc(clsDesc)+'</p>'+
            '</div>'+
            '<div class="panel">'+
              '<div class="panel-lbl">Knoblauch Sine-Wave Analysis</div>'+
              '<div class="knob-grid">'+kgrid+'</div>'+
              '<div class="knob-axis">'+
                '<div class="knob-axis-lbl">Axis Interpretation</div>'+
                '<div class="knob-axis-val" style="color:'+axC+'">'+esc(kn.beta>0.1?axLbl:'No significant axis detected')+'</div>'+
                (kn.beta>0.1?'<p class="knob-axis-desc">β = '+kn.beta.toFixed(3)+'. '+(kn.beta>0.5?'Strong bipolarity — consistent with a congenital or acquired color vision deficiency along this axis.':'Moderate bipolarity — may indicate mild weakness or fatigue in this color region.')+'</p>':'')+
              '</div>'+
            '</div>'+
            '<div class="panel">'+
              '<div class="panel-lbl">Error Distribution</div>'+
              '<div class="err-dist">'+
                '<div><div class="err-c-lbl">Perfect caps</div><div class="err-c-val" style="color:#22c55e">'+perfect+'</div></div>'+
                '<div><div class="err-c-lbl">Errors &gt; 0</div><div class="err-c-val" style="color:#f59e0b">'+errs+'</div></div>'+
                '<div><div class="err-c-lbl">Max error</div><div class="err-c-val" style="color:#ef4444">'+maxE+'</div></div>'+
                '<div><div class="err-c-lbl">TE½</div><div class="err-c-val" style="color:#e2e8f0">'+teh+'</div></div>'+
              '</div>'+
            '</div>'+
          '</div>'+
        '</div>'+
        '<div class="cap-scores">'+
          '<div class="panel-lbl">Individual Cap Scores (error = raw − 2)</div>'+
          '<div class="cs-chips">'+chips+'</div>'+
        '</div>'+
        '<div class="form-actions">'+
          '<button class="btn-secondary" data-a="back2">Back</button>'+
          '<button class="btn-primary" data-a="report">Generate Report →</button>'+
        '</div>'+
        '</div>';
    }
    /* ── Report (Certificate + Technical) ── */
    function htmlReport() {
      var r=state.results, s=state.sub, kn=r.knob;
      var cls=r.cls, isAdv=cls==='Superior', isAvg=cls==='Average';
      var ac2=axisClass(kn.a1), axLbl=axisLabel(kn.a1);
      var axC2=ac2==='protan'?'#c0392b':ac2==='deutan'?'#27ae60':ac2==='tritan'?'#2980b9':'#555';
      var clsC2=cls==='Superior'?'#166534':cls==='Average'?'#854d0e':'#7f1d1d';
      var lvlLbl=isAdv?'ADVANCED LEVEL':isAvg?'STANDARD LEVEL':'PROVISIONAL';
      var lvlDesc=isAdv?'Demonstrated superior color discrimination ability within the Advanced Level performance range.':isAvg?'Demonstrated satisfactory color discrimination ability within the Standard Level performance range.':'Color discrimination below standard range. Follow-up assessment recommended.';
      var lvlBg=isAdv?'#1a1a1a':isAvg?'#2c4a2c':'#4a2c2c';
      var lvlIcon=isAdv?'★':isAvg?'●':'○';
      /* certificate */
      var cert='<div class="cert-card">'+
        '<div class="cert-corner tl"></div><div class="cert-corner tr"></div><div class="cert-corner bl"></div><div class="cert-corner br"></div>'+
        '<div class="cert-inner">'+
          '<p class="cert-title">Color Vision Qualification</p>'+
          '<div class="cert-rule"><div class="cert-rule-line"></div><span class="cert-rule-txt">Certificate</span><div class="cert-rule-line"></div></div>'+
          '<p class="cert-sub">This certifies that</p>'+
          '<h1 class="cert-name">'+esc(s.name||'—')+'</h1>'+
          (s.reference?'<p class="cert-ref">'+esc(s.reference)+'</p>':'')+
          '<hr class="cert-gold-hr">'+
          '<p class="cert-body">has successfully completed the Farnsworth-Munsell 100 Hue Test<br>and is qualified for color-critical work at the following level:</p>'+
          '<div class="cert-badge-wrap"><div class="cert-badge" style="background:'+lvlBg+'"><span class="cert-badge-icon">'+lvlIcon+'</span><div><div class="cert-badge-level">'+lvlLbl+'</div><div class="cert-badge-tes">Total Error Score: '+r.tes+'</div></div></div></div>'+
          '<p class="cert-level-desc">'+esc(lvlDesc)+'</p>'+
          '<div class="cert-details">'+
            '<div><div class="cert-det-lbl">Test</div><div class="cert-det-val">FM 100-Hue</div></div>'+
            '<div class="cert-detail-div"></div>'+
            '<div><div class="cert-det-lbl">Date</div><div class="cert-det-val">'+esc(fmtDate(s.testDate,true))+'</div></div>'+
            '<div class="cert-detail-div"></div>'+
            '<div><div class="cert-det-lbl">Illumination</div><div class="cert-det-val">'+esc(s.illumination||'—')+'</div></div>'+
          '</div>'+
          '<div class="cert-sig-row"><div class="cert-sig">Authorized Signature</div><div class="cert-seal">FM</div><div class="cert-sig">Evaluator</div></div>'+
          '<p class="cert-foot">Serial: '+esc(s.serialNumber||'—')+' · Scored per Farnsworth (1957) / Knoblauch (1987) · fm100hue.app</p>'+
        '</div>'+
        '</div>';
      /* subject rows */
      var srows=[
        ['Total Error Score (TES):','<strong style="color:'+clsC2+'">'+r.tes+'</strong>'],
        ['Classification:','<strong style="color:'+clsC2+'">'+esc(r.lbl)+'</strong>'],
        ['Subject:',esc(s.name||'—')],
        ['Reference:',esc(s.reference||'—')],
        ['Years Old:',esc(s.dob||'−')],
        ['Date of Test:',esc(fmtDate(s.testDate,false))],
        ['Test Duration:',s.duration?esc(s.duration)+' mins':'—'],
        ['Gender:',esc(s.gender||'—')],
        ['Geographic Location:',esc(s.location||'—')],
        ['Industry Type:',esc(s.industry||'—')],
        ['Primary Job Function:',esc(s.jobFunction||'—')],
        ['Years of Experience:',esc(s.experience||'—')],
        ['Illumination Type:',esc(s.illumination||'—')]
      ];
      var srowH='';
      for(var sri=0;sri<srows.length;sri++){
        var rc=sri===1?'class="strong"':'';
        var wt=sri<=1?'700':'500';
        srowH+='<tr '+rc+'><td>'+esc(srows[sri][0])+'</td><td style="font-weight:'+wt+'">'+srows[sri][1]+'</td></tr>';
      }
      /* knoblauch rows */
      var kr=[['Mean Error (M)',kn.M.toFixed(3)],['Amplitude (A)',kn.A.toFixed(3)],['Modulation (β)',kn.beta.toFixed(3)],['Axis α₁',kn.a1.toFixed(1)],['Axis α₂',kn.a2.toFixed(1)],['SE ±1.96',(1.96*kn.SE_a).toFixed(1)+' caps'],['Axis interpretation',kn.beta>0.1?axLbl:'Non-specific']];
      var krH='';
      for(var ki2=0;ki2<kr.length;ki2++){
        var isAx=kr[ki2][0]==='Axis interpretation';
        krH+='<tr><td>'+esc(kr[ki2][0])+'</td><td style="font-weight:600;color:'+(isAx&&kn.beta>0.1?axC2:'#1a1a1a')+'">'+esc(kr[ki2][1])+'</td></tr>';
      }
      var tech='<div class="tech-report">'+
        '<div class="tech-hdr">'+
          '<div class="tech-brand"><div class="tech-seal">FM</div><div><div class="tech-brand-name">Munsell Color Services</div><div class="tech-brand-sub">Farnsworth-Munsell System</div></div></div>'+
          '<div class="tech-hdr-title"><p>Farnsworth-Munsell 100 Hue Test Results</p><p>Scored per Farnsworth (1957) / Knoblauch (1987)</p></div>'+
        '</div>'+
        '<div class="tech-plot">'+polarSVG(r,460,true)+'</div>'+
        '<div class="tech-data">'+
          '<div class="tech-col">'+
            '<p class="tech-sec-lbl"><strong>Results</strong></p>'+
            '<table class="tech-tbl"><tbody>'+srowH+'</tbody></table>'+
          '</div>'+
          '<div class="tech-col">'+
                        (s.serialNumber?'<p class="tech-sec-lbl">Test Serial Number: &nbsp;<span style="font-family:\'JetBrains Mono\',monospace;font-size:11px;font-weight:600">'+esc(s.serialNumber)+'</span></p>':'')+
            '<p class="tech-sec-lbl">Cap Order</p>'+
            '<p class="tech-cap-order">'+esc(r.seq.join(', '))+'</p>'+
            '<p class="tech-sec-lbl" style="margin-top:13px">Knoblauch Sine-Wave Analysis</p>'+
            '<table class="tech-tbl"><tbody>'+krH+'</tbody></table>'+
            '<p class="tech-certified">Certified.</p>'+
            (s.comments?'<p class="tech-sec-lbl" style="margin-top:9px">Comments</p><p class="tech-comments">'+esc(s.comments)+'</p>':'')+
          '</div>'+
        '</div>'+
        '<div class="tech-foot">'+
          '<div>'+
            '<p>Error score of 16 or less = <strong>Superior/Advanced</strong></p>'+
            '<p>Error score of 40 or less = <strong>Standard/Average</strong></p>'+
          '</div>'+
          '<div class="tech-foot-r">'+
            '<p style="font-family:\'Inter\',sans-serif;font-size:10px;color:#444;margin-bottom:1px">Test produced by: <strong>Munsell Color Services Laboratory</strong></p>'+
            '<p>fm100hue.app · Farnsworth (1957) / Knoblauch (1987)</p>'+
          '</div>'+
        '</div>'+
        '</div>';
      return '<div class="report-wrap">'+
        '<div class="report-head no-print">'+
          '<div><p class="eyebrow" style="margin-bottom:4px">Report</p><h2 class="step-title" style="margin-bottom:0">FM 100-Hue Test Documents</h2></div>'+
          '<div class="report-ctrl">'+
            '<button class="btn-secondary" data-a="back3">← Results</button>'+
            '<button class="fm-new-btn" data-a="newtest">New Test</button>'+
          '</div>'+
        '</div>'+
        tech +
        '</div>';
    }
    /* ── Kick off ── */
    render();
  } /* end initBlock */
  /* ═══════════════════════════════════════════════════════
     BOOTSTRAP
  ═══════════════════════════════════════════════════════ */
  function tryInit() {
    var els = document.querySelectorAll('[data-fm100="true"]');
    for (var i = 0; i < els.length; i++) {
      var safeId = els[i].getAttribute('data-safeid');
      if (!safeId) continue;
      if (!els[i]._fm100) {
        els[i]._fm100 = true;
        initBlock(els[i]);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var fresh = e.target.querySelectorAll('[data-fm100="true"]');
    for (var i = 0; i < fresh.length; i++) {
      fresh[i]._fm100 = false; /* reset so it re-inits */
    }
    tryInit();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
